import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PaymentSettingsService {
  private baseURL: string;

  constructor(private http: HttpClient,) {
    this.baseURL = environment.apiBaseUrl;
  }

  private options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  GetPaymentGateWays(): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/OnlinePaymentSettings/GetPaymentGateWays`,
      { observe: 'response' })
      .pipe(
        map(res => {
          return res.body as any;
        }),
        catchError(this.handleError)
      );
  }

  GetOnlinePaymentSettings(): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/OnlinePaymentSettings/GetOnlinePaymentSettings`,
      { observe: 'response' })
      .pipe(
        map(res => {
          return res.body as any;
        }),
        catchError(this.handleError)
      );
  }

  UpdateOrSaveOnlinePaymentSettings(Template: any): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/OnlinePaymentSettings/UpdateOrSaveOnlinePaymentSettings`;
    return this.http.post<any>(url, Template, options)
      .pipe(
        map(res => {
          const response = res as any[];
          return response;
        }),
        catchError(this.handleError)
      );
  }

  GetTerminalDevices(paymentGatewayId: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/OnlinePaymentSettings/GetTerminalDevices/${paymentGatewayId}`,
      { observe: 'response' })
      .pipe(
        map(res => res.body as any),
        catchError(this.handleError)
      );
  }

  SaveTerminalDevice(device: any): Observable<any> {

    const url = `${this.baseURL}/OnlinePaymentSettings/SaveTerminalDevice`;

    return this.http.post<any>(url, device, this.options)
      .pipe(
        map(res => res as any),
        catchError(this.handleError)
      );
  }

  DeleteTerminalDevice(id: number): Observable<any> {

    return this.http.delete<any>(
      `${this.baseURL}/OnlinePaymentSettings/DeleteTerminalDevice/${id}`,
      { observe: 'response' })
      .pipe(
        map(res => res.body as any),
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    console.error('server error:', error);
    if (error.error instanceof Error) {
      const errMessage = error.error.message;
      // this.appinsights.logEvent(errMessage);
      return throwError(errMessage);
    }
    return throwError(error || 'Node.js server error');
  }
}
